module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Frontbmatterbheads"
  }, [_vm._v("Stencilling")]), _vm._v(" "), _c('p', {
    staticClass: "P_Chapterbintrobtext"
  }, [_vm._v("Stencilling is an extremely effective way to add impressive decorations to your cakes and cookies quickly. For the best and most satisfying results, I recommend you use laser-cut culinary stencils made from durable food-grade plastic. How you choose to add a stencilled pattern will depend on the effect you wish to achieve and the size of the item to be stencilled. This taster from "), _c('em', [_vm._v("The Contemporary Cake Decorating Bible")]), _vm._v(" shows you various techniques using both edible dusts and royal icing; it also shows you how to make your own stencils and some possible other uses.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd337ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/fm.vue
// module id = 57
// module chunks = 0